module.exports = __webpack_public_path__ + "img/newswiper_2.f6598382.png";